import { useCanvasImage } from '~/core/hooks/useCanvasImage';
import {
  ApplianceModel,
  ColorModel,
  DrawingShape,
  PricedProduct,
} from '~/core/models';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { useDrawingShapeContext, usePricedProductsContext } from '~contexts';

const getAppliancesFromDrawingShapes = (
  drawingShapes: DrawingShape[]
): ApplianceModel[] =>
  drawingShapes.reduce<ApplianceModel[]>(
    (acc, shape) => [
      ...acc,
      ...shape.appliances.map(({ applianceModel }) => applianceModel),
    ],
    []
  );

export interface EstimateSummaryData {
  selectedColor?: ColorModel;
  canvasJpeg: string;
  pricedProducts: PricedProduct[];
  appliances: ApplianceModel[];
}

const useBuildEstimate = (): EstimateSummaryData => {
  const { pricedProducts } = usePricedProductsContext();
  const { canvasJpeg } = useCanvasImage();
  const selectedColor = useAppSelector(selectSelectedColor);

  const {
    getters: { drawingShapes },
  } = useDrawingShapeContext();

  const appliances = getAppliancesFromDrawingShapes(drawingShapes);

  return {
    selectedColor,
    canvasJpeg,
    pricedProducts,
    appliances,
  };
};

export default useBuildEstimate;
